import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { SuccessViewPanelTitle } from '@/features/dialogs/common/components/success-view/SuccessPanelTitle'
import { SuccessViewCheckmark } from '@/features/dialogs/common/components/success-view/SuccessViewCheckmark'
import { SuccessViewPanel } from '@/features/dialogs/common/components/success-view/SuccessViewPanel'
import { SuccessViewTokenRow } from '@/features/dialogs/common/components/success-view/SuccessViewTokenRow'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { Confetti } from '@/ui/molecules/confetti/Confetti'
import { cn } from '@/ui/utils/style'

export interface SuccessViewProps {
  from: Token
  amount: NormalizedNumber
  to: Token
  restartSwap: () => void
}

export function SuccessView({ from, amount, to, restartSwap }: SuccessViewProps) {
  return (
    <PageLayout>
      <Confetti recycle={false} numberOfPieces={1000} run />
      <Panel className="mx-auto mt-[66px] w-full max-w-2xl rounded-md sm:mt-[84px]">
        <SuccessViewCheckmark />
        <SuccessViewPanel>
          <div className={cn('flex flex-col gap-4 md:flex-row md:gap-9')}>
            <div className="flex grow flex-col gap-2">
              <SuccessViewPanelTitle>Swapped from</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={from} amount={amount} showUsdValue={false} />
            </div>
            <div className="flex grow flex-col gap-2">
              <SuccessViewPanelTitle>To</SuccessViewPanelTitle>
              <SuccessViewTokenRow token={to} amount={amount} showUsdValue={false} />
            </div>
          </div>
          <Button size="l" className="mt-4 w-full sm:mt-6" onClick={restartSwap}>
            Swap more
          </Button>
        </SuccessViewPanel>
      </Panel>
    </PageLayout>
  )
}
